var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white lh-1" },
    [
      _c("div", { staticClass: "flex items-center pad20-lr justify-between" }, [
        _c("div", { staticClass: "flex gray6 flex-auto" }, [
          _c(
            "div",
            {
              staticClass: "pad20-lr pointer class",
              class: { active: _vm.queryTypeList == null },
              on: {
                click: function($event) {
                  return _vm.classChange(null)
                }
              }
            },
            [
              _vm._v("\n        全部"),
              _vm.evaluateCollect.allAmount
                ? [_vm._v("(" + _vm._s(_vm.evaluateCollect.allAmount) + ")")]
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "pad20-lr pointer class",
              class: {
                active:
                  _vm.queryTypeList && _vm.queryTypeList.join(",") == "incFile"
              },
              on: {
                click: function($event) {
                  return _vm.classChange(["incFile"])
                }
              }
            },
            [
              _vm._v("\n        图/视频"),
              _vm.evaluateCollect.incFileAmount
                ? [
                    _vm._v(
                      "(" + _vm._s(_vm.evaluateCollect.incFileAmount) + ")"
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "pad20-lr pointer class",
              class: {
                active:
                  _vm.queryTypeList && _vm.queryTypeList.join(",") == "incZp"
              },
              on: {
                click: function($event) {
                  return _vm.classChange(["incZp"])
                }
              }
            },
            [
              _vm._v("\n        追评"),
              _vm.evaluateCollect.incReplyAmount
                ? [
                    _vm._v(
                      "(" + _vm._s(_vm.evaluateCollect.incReplyAmount) + ")"
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "pad20-lr pointer class",
              class: {
                active:
                  _vm.queryTypeList && _vm.queryTypeList.join(",") == "incHf"
              },
              on: {
                click: function($event) {
                  return _vm.classChange(["incHf"])
                }
              }
            },
            [
              _vm._v("\n        有回复"),
              _vm.evaluateCollect.incHfAmount
                ? [_vm._v("(" + _vm._s(_vm.evaluateCollect.incHfAmount) + ")")]
                : _vm._e()
            ],
            2
          )
        ]),
        _c(
          "div",
          {
            staticClass: "flex flex-column justify-center items-center pad20-tb"
          },
          [
            _c("div", { staticClass: "f20 mar5-b red" }, [
              _vm._v(_vm._s(_vm.goodsEvaRate) + "%")
            ]),
            _c("div", { staticClass: "gray6 f14" }, [_vm._v("好评率")])
          ]
        )
      ]),
      _vm.list && _vm.list.length
        ? [
            _vm._l(_vm.list, function(item, index) {
              return _c("commentItem", {
                key: index,
                attrs: { type: "user", detail: item, goodsVisible: false }
              })
            }),
            _c(
              "div",
              { staticClass: "pad20-tb pad10-lr text-right" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "prev, pager, next",
                    total: _vm.total,
                    "current-page": _vm.pageNum
                  },
                  on: { "current-change": _vm.currentChange }
                })
              ],
              1
            )
          ]
        : _c("div", { staticClass: "pad50 f14 text-center" }, [
            _vm._v("暂无数据")
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }